import styled from 'styled-components';
import { injectSpacing } from '../../../api/spacing/injectSpacing';
import { injectTypography } from '../../../utils/injectTypography';
import { getEasing } from '../../../utils/getEasing';
import { injectOSXFontSmoothing } from '../../../utils/injectOSXFontSmoothing';
export const inputSize = '24px';
export const fadeDuration = '0.25s';
export const StyledContainer = styled.div `
  display: grid;
  grid-row-gap: ${(props) => props.hasHint && `var(${props.theme.responsive.spacing.s})`};
  grid-column-gap: var(${(props) => props.theme.responsive.spacing.s});
  grid-template-rows:
    [ ${"interaction" /* interaction */} ] auto
    [ ${"description" /* description */} ] auto;
  grid-template-columns:
    [ ${"input" /* input */} ] ${inputSize}
    [ ${"label" /* label */} ] 1fr;

  ${injectSpacing('margin')}
`;
export const StyledInput = styled.input `
  display: flex;
  grid-row: ${"interaction" /* interaction */};
  grid-column: ${"input" /* input */};
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: ${inputSize};
  height: ${inputSize};

  margin: 0;
  overflow: hidden;

  border: 1px solid ${(props) => props.theme.colors.form.tertiary};
  outline-offset: 2px;

  transition: border-color ${fadeDuration} ${getEasing};

  appearance: none;

  /* Apperance: none causes the outline styles to be removed in Firefox.
   * This aims to restore native focus outline
   */
  &:-moz-focusring {
    outline-style: auto;
  }

  /* Checked */
  &:checked {
    border-color: ${(props) => props.theme.colors.form.tertiary};
  }

  /* Read only */
  &[readonly] {
    background-color: ${(props) => props.theme.colors.form.muted.tertiary};
    border-color: ${(props) => props.theme.colors.form.muted.tertiary};
  }

  /* Invalid */
  &:invalid {
    border-color: ${(props) => props.invalid && props.theme.colors.form.error};
    /* Remove glow in FF */
    box-shadow: none;
  }

  /* Disabled */
  &:disabled {
    background-color: transparent;
    border-color: ${(props) => props.theme.colors.form.muted.secondary};

    cursor: not-allowed;
    opacity: 1;
  }

  /* Enabled
   * Input type radio/checkbox has no native :read-only support
   */
  &:enabled:not([readonly]) {
    cursor: pointer;
  }

  /* Focus */
  &:enabled:valid:not([readonly]):focus {
    border-color: ${(props) => props.theme.colors.form.strong};
  }

  /* Hover */
  &:enabled:valid:not([readonly]):hover {
    border-color: ${(props) => props.theme.colors.form.strong};
  }

  /* Checked hover */
  &:enabled:not([readonly]):valid:checked:hover {
    border-color: ${(props) => props.theme.colors.form.strong};
  }

  @media (prefers-reduced-motion: reduce) {
    &::before {
      transition: none;
    }
  }
`;
export const StyledLabel = styled.label `
  grid-row: ${"interaction" /* interaction */};
  grid-column: ${"label" /* label */};
  justify-self: start;

  color: ${(props) => props.theme.colors.form.primary};

  transition: color ${fadeDuration} ${getEasing};

  ${(props) => injectTypography(props, 'copy1')}
  ${injectOSXFontSmoothing(true)}

  /* Focus */
  ${StyledInput}:enabled:valid:not([readonly]) + &:focus,
  ${StyledInput}:enabled:valid:not([readonly]):focus + & {
    color: ${(props) => props.theme.colors.form.strong};
  }

  /* Hover */
  ${StyledInput}:enabled:valid:not([readonly]) + &:hover,
  ${StyledInput}:enabled:valid:not([readonly]):hover + & {
    color: ${(props) => props.theme.colors.form.strong};
  }

  /* Checked */
  ${StyledInput}:checked + & {
    color: ${(props) => props.theme.colors.form.primary};
  }

  /* Read only
   * Input type radio/checkbox has no native :read-only support
   */
  ${StyledInput}[readonly] + & {
    color: ${(props) => props.theme.colors.form.strong};
  }

  /* Invalid */
  ${StyledInput}:invalid + & {
    color: ${(props) => props.invalid && props.theme.colors.form.error};
  }

  /* Disabled */
  ${StyledInput}:disabled + & {
    color: ${(props) => props.theme.colors.form.secondary};
  }

  /* Enabled
   * Input type radio/checkbox has no native :read-only support
   */
  ${StyledInput}:enabled:not([readonly]) + & {
    cursor: pointer;
  }
`;
export const StyledDescriptionContainer = styled.div `
  grid-row: ${"description" /* description */};
  grid-column: ${"label" /* label */};
`;
//# sourceMappingURL=GenericOption.styles.js.map